enum SortOrder {
    ASC = "asc",
    DESC = "desc",
}

export { SortOrder };
